import {Editor} from 'tinymce';

import {generateMenuItemsCallback} from './utils';

const register = (editor: Editor): void => {
  const onAction = (value: string) => {
    editor.execCommand('pmAddMergeTag', false, value);
  }

  editor.ui.registry.addMenuButton('merge_tags', {
    icon: 'addtag',
    text: 'Merge Fields',
    tooltip: 'Select merge tag',
    fetch: generateMenuItemsCallback(editor, onAction),
    onSetup: (api: any) => {

    },
  } as any);
};

export {
  register
};
